import { Box, Typography, theme } from '@sbv-clients/ui-shared';

import { useArrivalsGet } from '../../../../services/dashboard';
import useUnscheduledReportModal from '../unscheduled-modal';
import ArrivalsTable from './arrivals-table';

interface ArrivalsProps {
  departmentId: number;
  positionId: number;
  startDate: Date;
}

const Arrivals = ({ departmentId, positionId, startDate }: ArrivalsProps) => {
  const { data, isLoading } = useArrivalsGet(
    departmentId,
    positionId,
    startDate
  );
  const { arrivalsResponse: arrivals = [], unscheduledArrivals = [] } =
    data || {};
  const { modal, openModal } = useUnscheduledReportModal();
  return (
    <Box width="100%">
      <Typography variant="subtitle2" my={3} color={theme.text.sectionSubtitle}>
        Arrivals
      </Typography>
      <ArrivalsTable
        data={arrivals}
        unScheduledArrivals={unscheduledArrivals}
        openModal={openModal}
        isLoading={isLoading}
      />
      {modal}
    </Box>
  );
};

export default Arrivals;
